module.exports = __webpack_public_path__ + "static/project-5-after-28e584e1927f47c4da59f8b6674ad309.png";